import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      {
        path: '/',
        name: 'Apps',
        component: () => import( '../views/Apps.vue')
      },
      {
        path: '/channel',
        name: 'Channel',
        component: () => import( '../views/Channel.vue')
      },
      {
        path: '/sign',
        name: 'Sign',
        component: () => import( '../views/Sign.vue')
      },
      {
        path: '/tasks',
        name: 'Tasks',
        component: () => import( '../views/Tasks.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
